import ApplicationComponent from "legacy/ApplicationComponent"
import LegacyButton from "legacy/LegacyButton"
import AuthLauncher from "legacy/auth/AuthLauncher"
import CustomFieldsForm from "legacy/boater-reservation-flow/boater-inquiry-flow/CustomFieldsForm"
import InquiryBoatForm from "legacy/boater-reservation-flow/boater-inquiry-flow/InquiryBoatForm"
import InquiryContactForm from "legacy/boater-reservation-flow/boater-inquiry-flow/InquiryContactForm"
import InquiryInsuranceAndRegistrationForm from "legacy/boater-reservation-flow/boater-inquiry-flow/InquiryInsuranceAndRegistrationForm"
import InquiryOverview from "legacy/boater-reservation-flow/boater-inquiry-flow/InquiryOverview"
import { afterSetState } from "legacy/helpers.es6"
import _ from "lodash"
import PropTypes from "prop-types"
import React from "react"

class InquiryFlowController extends ApplicationComponent {
  constructor(args) {
    super(args)
    this.state = {
      insurance: {},
      registration: {},
      customFields: {},
      specialRequest: "",
      contact: this.props.contact,
      currentPage: "InquiryBoatForm",
      transactionType: "",
      startDate: "",
      endDate: "",
    }
    this.navigationStack = ["InquiryBoatForm"]
    this.pageOrder = [
      "InquiryBoatForm",
      "InquiryInsuranceAndRegistrationForm",
      "InquiryContactForm",
      "InquiryCustomFieldsForm",
      "InquiryOverview",
    ]
  }

  shouldShowContactForm() {
    return (
      !this.state.contact ||
      !this.state.contact.email ||
      !this.state.contact.phone ||
      !this.state.contact.name
    )
  }

  handleBack() {
    this.navigationStack.pop()
    this.setState({
      currentPage: this.navigationStack[this.navigationStack.length - 1],
    })
    afterSetState(() => {
      this.props.hideHeader(this.state.currentPage !== "InquiryBoatForm")
    })
  }

  handleBoat(boat) {
    const newState = { boat }
    if (boat.id) {
      const foundBoat = _.find(this.props.contact.boats, { id: boat.id })
      newState.insurance = foundBoat.insurance || {}
      newState.registration = foundBoat.registration || {}
    } else {
      if (this.state.insurance.encodedId) {
        newState.insurance = {}
      }
      if (this.state.registration.encodedId) {
        newState.registration = {}
      }
    }
    this.setState(newState)
    afterSetState(() => {
      this.handleContinue()
    })
  }

  handleInsuranceRegistration(insurance, registration) {
    this.setState({ insurance, registration })
    afterSetState(() => {
      this.handleContinue()
    })
  }

  handleContact(contact) {
    this.setState({ contact })
    afterSetState(() => {
      this.handleContinue()
    })
  }

  handleCustomFields(customFields) {
    this.setState({ customFields }, this.handleContinue())
  }

  handleSpecialRequest(specialRequest) {
    this.setState({ specialRequest })
  }

  handleTransactionType(transactionType) {
    this.setState({ transactionType })
    this.handleAmplitude("inquiry_flow:transaction_type_pressed", {
      transaction_type: transactionType,
    })
  }

  handleStartDate(startDate) {
    this.setState({ startDate })
  }

  handleEndDate(endDate) {
    this.setState({ endDate })
  }

  handleContinue() {
    if (this.state.currentPage === "InquiryContactForm") {
      this.handleAmplitude("inquiry_flow:contact_info_continue_pressed")
    }
    if (this.state.currentPage === "InquiryBoatForm") {
      this.handleAmplitude("inquiry_flow:boat_info_continue_pressed")
    }
    const nextPage = this.nextPage(this.state.currentPage)
    this.navigationStack.push(nextPage)
    this.setState({ currentPage: nextPage })
    this.props.hideHeader(nextPage !== "InquiryBoatForm")
  }

  handleAmplitude(eventName, details = {}) {
    Amplitude.trackEvent(eventName, {
      marina_id: this.props.marina.mcom_id,
      marina_name: this.props.marina.name,
      experience_name: "inquiry_flow",
      visible_form: this.props.visibleForm,
      ...details,
    })
  }

  nextPage(currentPage) {
    const showReg =
      this.props.registrationRequirement !== "none" &&
      (!this.state.boat.id ||
        !this.state.registration.number ||
        !this.state.registration.expirationDate)
    const showInsurance =
      this.props.insuranceRequirement !== "none" &&
      (!this.state.boat.id ||
        !this.state.insurance.companyName ||
        !this.state.insurance.policyNumber ||
        !this.state.insurance.expirationDate)

    if (
      this.canNavigateToPage(
        "InquiryInsuranceAndRegistrationForm",
        currentPage
      ) &&
      (showReg || showInsurance)
    ) {
      return "InquiryInsuranceAndRegistrationForm"
    } else if (
      this.canNavigateToPage("InquiryContactForm", currentPage) &&
      this.shouldShowContactForm()
    ) {
      return "InquiryContactForm"
    } else if (
      this.canNavigateToPage("InquiryCustomFieldsForm", currentPage) &&
      this.props.customFields.length > 0
    ) {
      return "InquiryCustomFieldsForm"
    } else {
      return "InquiryOverview"
    }
  }

  canNavigateToPage(page, currentPage) {
    // If the page is a past page or current page we don't want to navigate to it
    // We only want to navigate "forward" in the stack
    return this.pageOrder.indexOf(currentPage) < this.pageOrder.indexOf(page)
  }

  renderLoginSection() {
    if (!this.props.contact.id && !this.props.whiteLabel) {
      return (
        <div>
          <p className="inline">Have a Dockwa Account?</p>
          <div className="ml-2 inline-block">
            <AuthLauncher
              type="login"
              amplitudeEvent={{
                eventName: "inquiry_flow:log_in_pressed",
                eventProperties: {
                  marina_id: this.props.marina.mcom_id,
                  marina_name: this.props.marina.name,
                  experience_name: "inquiry_flow",
                  visible_form: this.props.visibleForm,
                },
              }}
            />
          </div>
          <hr />
        </div>
      )
    }
  }

  renderFormBody() {
    switch (this.state.currentPage) {
      case "InquiryBoatForm":
        return (
          <div>
            <p className="leading-relaxed text-gray-800">
              Make an inquiry to learn more about long-term dockage, storage,
              and other marina services.
            </p>
            {this.renderLoginSection()}
            <InquiryBoatForm
              boat={this.state.boat}
              boats={this.props.contact.boats}
              depthConstraint={
                this.props.marina.verticalConstraints &&
                this.props.marina.verticalConstraints.depth &&
                this.props.marina.verticalConstraints.depth <= 15
                  ? this.props.marina.verticalConstraints.depth
                  : null
              }
              heightConstraint={
                this.props.marina.verticalConstraints &&
                this.props.marina.verticalConstraints.height
                  ? this.props.marina.verticalConstraints.height
                  : null
              }
              handleBoat={this.handleBoat.bind(this)}
            />
          </div>
        )
      case "InquiryInsuranceAndRegistrationForm":
        return (
          <InquiryInsuranceAndRegistrationForm
            insurance={this.state.insurance}
            registration={this.state.registration}
            registrationRequirement={this.props.registrationRequirement}
            insuranceRequirement={this.props.insuranceRequirement}
            handleInsuranceRegistration={this.handleInsuranceRegistration.bind(
              this
            )}
          />
        )
      case "InquiryContactForm":
        return (
          <InquiryContactForm
            contact={this.state.contact}
            handleContact={this.handleContact.bind(this)}
          />
        )
      case "InquiryCustomFieldsForm":
        return (
          <CustomFieldsForm
            customFields={this.props.customFields}
            handleCustomFields={this.handleCustomFields.bind(this)}
            marinaName={this.props.marina.name}
            embedForm={this.props.embedForm}
            context={{ type: "Inquiry" }}
            buttonClassName={"btn btn-primary w-full"}
            buttonText={"Continue"}
          />
        )
      case "InquiryOverview":
        return (
          <InquiryOverview
            marina={this.props.marina}
            boat={this.state.boat}
            contact={this.state.contact}
            insurance={this.state.insurance}
            registration={this.state.registration}
            customFields={this.state.customFields}
            specialRequest={this.state.specialRequest}
            handleSpecialRequest={this.handleSpecialRequest.bind(this)}
            postUrl={this.props.postUrl}
            embedForm={this.props.embedForm}
            androidRequest={this.props.androidRequest}
            visibleForm={this.props.visibleForm}
            transactionType={this.state.transactionType}
            handleTransactionType={this.handleTransactionType.bind(this)}
            transactionTypes={this.props.transactionTypes}
            startDate={this.state.startDate}
            handleStartDate={this.handleStartDate.bind(this)}
            endDate={this.state.endDate}
            handleEndDate={this.handleEndDate.bind(this)}
          />
        )
    }
  }

  renderBackButton() {
    if (this.state.currentPage !== "InquiryBoatForm") {
      return (
        <LegacyButton
          type="button"
          onClick={this.handleBack.bind(this)}
          className="btn btn-secondary col-span-1 h-10"
          icon="icon-angle-left"
        >
          back
        </LegacyButton>
      )
    }
  }

  renderHeader() {
    let header = ""
    switch (this.state.currentPage) {
      case "InquiryBoatForm":
        header = ""
        break
      case "InquiryInsuranceAndRegistrationForm":
        header = "Documentation"
        break
      case "InquiryContactForm":
        header = "Contact"
        break
      case "InquiryCustomFieldsForm":
        header = "Additional Info"
        break
      case "InquiryOverview":
        header = "Details"
        break
    }
    if (header) {
      return (
        <div>
          <div className="grid grid-cols-5">
            {this.renderBackButton()}
            <h2 className="col-span-3 mb-0 text-center text-xl font-normal leading-casual">
              {header}
            </h2>
          </div>
          <hr />
        </div>
      )
    }
  }

  render() {
    return (
      <div className="p-4">
        {this.renderHeader()}
        <div className="reservation-body">{this.renderFormBody()}</div>
      </div>
    )
  }
}

InquiryFlowController.propTypes = {
  contact: PropTypes.object.isRequired,
  marina: PropTypes.shape({
    mcom_id: PropTypes.string,
    name: PropTypes.string,
    verticalConstraints: PropTypes.shape({
      depth: PropTypes.number,
      height: PropTypes.number,
    }),
  }).isRequired,
  hideHeader: PropTypes.func.isRequired,
  registrationRequirement: PropTypes.string,
  insuranceRequirement: PropTypes.string,
  customFields: PropTypes.array,
  postUrl: PropTypes.string,
  embedForm: PropTypes.bool,
  androidRequest: PropTypes.bool,
  visibleForm: PropTypes.string,
  transactionTypes: PropTypes.object,
  whiteLabel: PropTypes.bool,
}

export default InquiryFlowController
